import React, { useState } from "react";
import Modal from "@restart/ui/Modal";
import { CloseIcon, EditIcon } from "asset/icons";
import Avatar from "component/avatar";
import Input from "component/form/Input";
import AssignAgentModal from "./AssignAgentModal";
import getInitialsMessage from "utilities/messages/getInitialsMessage";
import AssignShippingAgent from "../components/AssignShippingAgent";
import { useMutation } from "react-query";
import { handleEditShipper } from "api/fetchers";
import Loader from "component/loader";
import { toast } from "react-toastify";

const shippingType = { Truck: "Trucker (Driver)", "Sea Freight": "Clearing agent" };

const EditShipperModal = ({ show, shippers, onUpdate, onClose, refetchData, shipmentId }) => {
    const [editedShippers, setEditedShippers] = useState([...shippers]);
    const [selectedShipperIndex, setSelectedShipperIndex] = useState(null);
    const [showAssignAgentModal, setShowAssignAgentModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState();
    const [loading, setLoading] = useState(false);

    const handleAssignAgent = (agent) => {
        const updatedShippers = [...editedShippers];
        updatedShippers[selectedShipperIndex] = {
            ...updatedShippers[selectedShipperIndex],
            agentName: agent?.name,
            business: agent?.business,
            agentEmail: agent?.email,
            agent: agent?._id,
        };
        setEditedShippers(updatedShippers);
        setSelectedShipperIndex(agent)
        setShowAssignAgentModal(false);
    };

    const { mutateAsync: handleEditShipperFunc, isLoading: editingShipperLoading,  } = useMutation({
        mutationFn: ({ data }) => handleEditShipper({ shipmentId, data }),
        mutationKey: ["editShipper", shipmentId],
        onSuccess: (data) => {
            if (data?.status !== 400) {
                toast.success(
                    data?.data?.message || data?.message || "Shipper updated successfully"
                );
                onUpdate();
                refetchData();
            } else {
                toast.error(data?.message?.[0] || "Error updating shipper");
                onUpdate();
            }
            setLoading(false);
        },
    });
    
    return (
        <>
            <Modal
                show={show}
                onHide={onClose}
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[900]"
            >
                <div className="bg-white rounded-2xl p-6 w-full max-w-[600px] md:max-w-[700px] lg:max-w-[600px] shadow-xl">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="text-xl font-semibold text-[#1D2939]">Edit Shipper</h2>
                        <CloseIcon
                            className="cursor-pointer w-6 h-6 text-[#667085]"
                            onClick={onClose}
                        />
                    </div>

                    {/* Shippers List */}
                    <div className="space-y-6">
                        {editedShippers.map((shipper, index) => (
                            <div key={index}>
                                <p className="text-sm font-medium text-[#344054]">
                                    {shippingType[shipper?.type]}
                                </p>
                                <div className="flex items-center justify-between border border-[#F9FAFB] px-4 py-3 rounded-xl mt-2">
                                    <div className="flex items-center gap-2">
                                        <div className="flex items-center justify-center w-10 h-10 font-semibold text-white bg-gray-300 rounded-full">
                                            {getInitialsMessage(shipper?.agentName)}
                                        </div>
                                        <div>
                                            <h3 className="text-lg text-capitalize mb-0 text-[#101828] font-semibold">
                                                {shipper?.agentName}
                                            </h3>
                                            <p className="text-xs text-[#667085]">
                                                {shipper?.type}
                                            </p>
                                        </div>
                                    </div>
                                    <EditIcon
                                        className="cursor-pointer text-[#6F00FF]"
                                        onClick={() => {
                                            setSelectedShipperIndex(index);
                                            setShowAssignAgentModal(true);
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end gap-2 mt-6">
                        <button
                            className="text-[#344054] px-4 py-2 rounded-lg hover:bg-gray-100 transition"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="bg-[#6F00FF] text-white px-6 py-2 rounded-lg shadow-md hover:bg-[#5A00E0] transition"
                            disabled={editingShipperLoading}
                            onClick={() => {
                                setLoading(true);
                                handleEditShipperFunc({
                                    data: {
                                        shipmentDetailId: shipmentId,
                                        email: editedShippers[0]?.agentEmail,
                                        name: editedShippers[0]?.agentName,
                                        id: editedShippers[0]?.agent,
                                    },
                                });
                                onUpdate(editedShippers);
                                onClose();
                            }}
                        >
                            {editingShipperLoading || loading ? <Loader /> : "Update Shippers"}
                        </button>
                    </div>
                </div>
            </Modal>

            {showAssignAgentModal && (
                <AssignShippingAgent
                    setSelectedUser={handleAssignAgent}
                    selectedUser={selectedUser}
                    show={showAssignAgentModal}
                    setShow={setShowAssignAgentModal}
                />
            )}
            {/* Assign Agent Modal */}
            {/* {showAssignAgentModal && (
                <AssignAgentModal
                    show={showAssignAgentModal}
                    onClose={() => setShowAssignAgentModal(false)}
                    agents={[
                        {
                            name: "Antoinette Harret",
                            business: "ME Shipping",
                            email: "harret@me.com",
                        },
                        { name: "Baba Olonbo", business: "BO Logistics", email: "baba@bo.com" },
                        { name: "Babayaro Nagaro", business: "BN Lines", email: "naga@bn.com" },
                        {
                            name: "Antoinette Harret",
                            business: "ME Shipping",
                            email: "harret@me.com",
                        },
                        { name: "Baba Olonbo", business: "BO Logistics", email: "baba@bo.com" },
                        { name: "Babayaro Nagaro", business: "BN Lines", email: "naga@bn.com" },
                        { name: "Cabayaro Jagaro", business: "CN Lines", email: "naga@bn.com" },
                    ]}
                    onSelect={handleAssignAgent}
                />
            )} */}
        </>
    );
};

export default EditShipperModal;
